import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

function rupee(n) { return `₹${Number(n).toLocaleString("en-IN")}`; }

export default function Orders() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api.get("/orders").then(({ data }) => setOrders(data)).finally(() => setLoading(false));
  }, [user]);

  if (!user) return <div className="px-6 md:px-24 py-24 text-center"><div className="font-serif-h text-3xl">Sign in to view orders</div><Link to="/login" className="btn-ink mt-6 inline-flex">Sign In</Link></div>;

  return (
    <div className="px-6 md:px-12 lg:px-24 py-16 min-h-[70vh]" data-testid="orders-page">
      <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Your History</div>
      <h1 className="font-serif-h font-light text-5xl text-stone-900">My Orders</h1>

      {loading ? (
        <div className="mt-12 text-stone-500">Loading...</div>
      ) : orders.length === 0 ? (
        <div className="mt-16 text-center py-16 border border-warm">
          <div className="font-serif-h text-2xl">No orders yet</div>
          <Link to="/shop/sarees" className="btn-ink mt-6 inline-flex">Start Shopping</Link>
        </div>
      ) : (
        <div className="mt-12 space-y-8">
          {orders.map((o) => (
            <div key={o.id} className="border border-warm bg-white p-6 md:p-8">
              <div className="flex flex-wrap justify-between gap-3 mb-6">
                <div>
                  <div className="text-[11px] tracking-overline uppercase text-stone-500">Order #{o.id.slice(0,8).toUpperCase()}</div>
                  <div className="text-sm text-stone-700 mt-1">{new Date(o.created_at).toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</div>
                </div>
                <div className="text-right">
                  <div className="text-[11px] tracking-overline uppercase text-[#D4AF37]">{o.status}</div>
                  <div className="font-medium mt-1">{rupee(o.total)}</div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {o.items.map((it) => (
                  <div key={`${it.product_id}-${it.size}`} className="flex gap-4">
                    <img src={it.image} className="w-16 h-20 object-cover bg-[#F3EAE8]" alt=""/>
                    <div className="text-sm">
                      <div className="font-medium">{it.name}</div>
                      <div className="text-stone-500 text-xs">Size {it.size} · Qty {it.quantity}</div>
                      <div className="mt-1">{rupee(it.price)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
